import { useState } from 'react'

export default function useRequestLock() {
    const [isLocked, setIsLocked] = useState(false)

    const withLock = async (callback) => {
        if (isLocked) {
            console.log('Запрос заблокирован: операция уже выполняется')
            return
        }

        try {
            setIsLocked(true)
            console.log('Запрос начат: блокировка активирована')
            await callback()
        } finally {
            setIsLocked(false)
            console.log('Запрос завершен: блокировка снята')
        }
    }

    return {
        isLocked,
        withLock
    }
}